
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/cpa",
      function () {
        return require("private-next-pages/[locale]/cpa/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/cpa"])
      });
    }
  